import { render } from "./CompanySubscriptions.vue?vue&type=template&id=15f9964c&ts=true"
import script from "./CompanySubscriptions.vue?vue&type=script&lang=ts"
export * from "./CompanySubscriptions.vue?vue&type=script&lang=ts"

import "./CompanySubscriptions.vue?vue&type=style&index=0&id=15f9964c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__